// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { HeaderOnboardingComponent } from '@openbank/ziniaweb-ui-components';
import { HeaderLayoutModalComponent } from './components/modal/header-layout-modal.component';
// Constants
import { ENTRYPOINT_HEADER_COMPONENT_PROPS } from './constants/header-layout.constants';
// Hooks
import { useHeaderLayoutHook } from './hooks/header-layout.hook';
// Styles
import {
  HeaderLayoutContentComponentStyled,
  HeaderLayoutHeaderComponentStyled,
} from './header-layout.component.styled';
// Translations
import { BACK } from './translations/header-layout.translations';
// Types
import { ReactChildrenType } from '@openbank/ziniaweb-ui-core-models';

const HeaderLayoutComponent = ({ children }: ReactChildrenType): React.ReactElement => {
  const {
    disableBack,
    handleGoBackToAmazonButtonClick,
    handleCloseDropModalActionClick: onClose,
    showDropModal,
  } = useHeaderLayoutHook();

  return (
    <>
      <HeaderLayoutHeaderComponentStyled>
        <HeaderOnboardingComponent
          {...ENTRYPOINT_HEADER_COMPONENT_PROPS}
          button={{
            children: <FormattedMessage id={BACK} />,
            disabled: disableBack,
            onClick: handleGoBackToAmazonButtonClick,
          }}
        />
      </HeaderLayoutHeaderComponentStyled>
      <HeaderLayoutContentComponentStyled>{children}</HeaderLayoutContentComponentStyled>
      <HeaderLayoutModalComponent {...{ onClose, showDropModal }} />
    </>
  );
};

export { HeaderLayoutComponent };
